var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.244 3.46138C33.244 3.46138 33.7705 1.90138 32.6395 0.809378C31.606 -0.204621 30.2605 0.341378 30.2605 0.341378C29.071 0.926378 19.0285 7.10788 15.304 11.2029C13.627 13.0749 11.287 18.5934 13.1785 20.6019C14.9725 22.5129 20.9005 20.2704 22.519 18.6519C26.536 14.6349 32.6785 4.67038 33.244 3.46138ZM0.230469 30.9174C4.85197 27.8754 3.07747 24.2679 6.52897 21.8694C8.34247 20.6019 10.858 20.6604 12.535 22.4349C13.7635 23.7414 14.095 27.4464 12.223 29.1819C9.16147 32.0094 4.42297 32.2044 0.230469 30.9174Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileFrame);
export default __webpack_public_path__ + "static/media/profile-frame.be9b7e97ed177a459e4f146174315a89.svg";
export { ForwardRef as ReactComponent };